const settings = Object.freeze({
    urlBase: webserviceBaseURL,
});

export {
    settings
};